module.exports = __webpack_public_path__ + "static/assets/eb54a994349a98f444db9dab40519420.png";